import axios from "axios";
import { reactive } from "@vue/composition-api";

// This file loads configuration from .env.xxx files if rendered on server
// and from public/config/config.json while running in browser.
// IRL when this app is served as a static assets
// file public/config/config.json will be shadowed by configMap mounted over it.

export const status = reactive({
  loaded: false,
});

interface Config {
  [key: string]: string | undefined;
}

const config: Config = {
  APP_NAME: process.env.APP_NAME,
  SSO_CLIENT_ID: process.env.SSO_CLIENT_ID,
  BASE_URL: process.env.VUE_APP_BASE_URL,
  BASE_API_URL: process.env.VUE_APP_BASE_URL,
  AUTH_URL: process.env.VUE_APP_AUTH_URL,
  AUTH_CALLBACK_URL: process.env.VUE_APP_AUTH_CALLBACK_URL,
  DEFAULT_REDIRECT_URL: process.env.VUE_FALLBACK_LOGIN_REDIRECT_URL,
  AMPLITUDE_API_KEY: process.env.VUE_APP_AMPLITUDE_API_KEY,
};
export default config;
export function getConfig(): Config {
  return Object.assign({}, config) as Config;
}

export async function retrieveConfig() {
  const rnd = Math.random().toString().slice(2);
  const url = `/config/config.json?v=${rnd}`;
  // if (process.env.NODE_ENV === "test") {
  //   Object.assign(config, await getTestData("config") as Config)
  //   return true
  // }
  // noinspection ES6MissingAwait
  try {
    const r = await axios.get(url);
    Object.assign(config, r.data as Config);
    checkConfig();
    status.loaded = true;
    console.log("Loaded config");
    return true;
  } catch (err) {
    console.error(`Failed to load configuration from ${url}`);
    console.error(err);
    return false;
  }
}

let configRequest: Promise<boolean> | undefined;
export function loadConfig(): Promise<boolean> {
  if (!configRequest) configRequest = retrieveConfig();
  return configRequest;
}

function checkConfig() {
  for (const key in config) {
    if (!config[key]) {
      console.error("Configuration key is missing:", key);
    }
  }
}

async function getApiStatus(): Promise<any | undefined> {
  const path = "/status";
  try {
    const r = await axios.get(path);
    if (r && "version" in r.data) {
      return r.data;
    } else {
      console.error(`Failed to read API ${path}. Unexpected response:`, r.data);
    }
  } catch (err) {
    console.error(`Failed to read API from ${path}: ${err}`);
    return "API unavailable";
  }
}

export async function getVersion() {
  if (process.env.NODE_ENV === "test") {
    return;
  }
  const apiResp = await getApiStatus();
  if (apiResp && apiResp.version) {
    console.log("Version:", apiResp.version);
    return apiResp.version;
  }
  return "failed to retrieve";
}
